import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { BuscarModuloPipe } from '../pipes/buscar-modulo.pipe';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  usuario: any = {};
  busqueda: string;
  nuevo = false;
  tiene = 0;
  menu: any[] = [];
  modulo: string;
  modulo_actual: string;
  tamano = document.body.clientHeight;
  permisos = JSON.parse(localStorage.getItem("permisos"));
  path = "";
  constructor(private title: Title, ) { }

  ngOnInit() {
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    let menu = JSON.parse(localStorage.getItem('menu'));

    let url = location.href.split('/');
    this.modulo = url[4];
    this.modulo_actual = this.modulo.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });

    for (let item of menu) {
      if (item.path.indexOf(this.modulo_actual.toLowerCase()) > -1) {
        if (this.menu.indexOf(item) < 0) {
          this.menu.push(item);
        }
      }
    }
  }
  tiene_hijos(){
    this.tiene++;
  }
  abrirLista(item){
    if(!this.nuevo){
      this.path = item.path;
      this.ir();
    }
  }

  abrirNuevo(item){
    this.nuevo = true;
    let key = item.key.split(".");
    if(this.permisos.indexOf(key[0] + ".store") > -1){
      let ruta = item.path.replace("lista", "nuevo");
      this.path = ruta;
      this.ir();
    }else{
      this.path = item.path;
      this.ir();
    }
  }
  ir(){
    setTimeout(() => {
      document.getElementById("redirect").click();
    }, 50);
  }
}
